import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import { jwtDecode } from 'jwt-decode';
function getClientTime() {
  return Math.round(Date.now() / 1000);
}
var _token = /*#__PURE__*/_classPrivateFieldLooseKey("token");
var _approximateClientExpire = /*#__PURE__*/_classPrivateFieldLooseKey("approximateClientExpire");
var _requestDelay = /*#__PURE__*/_classPrivateFieldLooseKey("requestDelay");
class TokenCache {
  constructor(token, requestDelay) {
    Object.defineProperty(this, _token, {
      writable: true,
      value: null
    });
    /**
     * The expire value of the token adjusted to the client's Date.now()
     * value that might be different from the one of the server depending
     * on the client's clock.
     */
    Object.defineProperty(this, _approximateClientExpire, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _requestDelay, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _requestDelay)[_requestDelay] = requestDelay;
    if (token) {
      this.set(token);
    }
  }
  get() {
    return _classPrivateFieldLooseBase(this, _token)[_token];
  }

  /**
   *
   * @param token
   */
  set(token) {
    if (typeof token !== 'string') {
      throw new Error(`Token is invalid. String expected, got ${typeof token}.`);
    }
    let decodedToken;
    try {
      decodedToken = jwtDecode(token);
    } catch (e) {
      throw new Error('Could not decode JWT');
    }
    const {
      exp: expire,
      iat: issuedAt
    } = decodedToken;
    if (typeof expire !== 'number' || typeof issuedAt !== 'number') {
      throw new Error('JWT does not contain any value for issuedAt or expire');
    }
    const deltaClientServer = getClientTime() - issuedAt;
    _classPrivateFieldLooseBase(this, _approximateClientExpire)[_approximateClientExpire] = expire + deltaClientServer;
    _classPrivateFieldLooseBase(this, _token)[_token] = token;
  }
  isExpired() {
    return getClientTime() > _classPrivateFieldLooseBase(this, _approximateClientExpire)[_approximateClientExpire] - _classPrivateFieldLooseBase(this, _requestDelay)[_requestDelay];
  }
  isValid() {
    return _classPrivateFieldLooseBase(this, _token)[_token] !== null && !this.isExpired();
  }
  invalidate() {
    _classPrivateFieldLooseBase(this, _token)[_token] = null;
    _classPrivateFieldLooseBase(this, _approximateClientExpire)[_approximateClientExpire] = 0;
  }
}
export default TokenCache;
//# sourceMappingURL=TokenCache.js.map